import { get } from 'lodash';
import replaceDataAndAttributes from './replaceDataAndAttributes';

function getErrorTranslation(errorKey, translations = {}, htmlAttributes = {}) {
    return replaceDataAndAttributes(
        get(translations, errorKey, errorKey),
        {},
        htmlAttributes
    );
}

function getErrorTranslations(
    errorKeys,
    translations = {},
    htmlAttributes = {}
) {
    if (!Array.isArray(errorKeys)) {
        return getErrorTranslation(errorKeys, translations, htmlAttributes);
    }

    return errorKeys
        .reduce((previousMessage, errorKey) => {
            const htmlAttr = htmlAttributes[errorKey];
            return `${previousMessage}${getErrorTranslation(
                errorKey,
                translations,
                htmlAttr
            )}`;
        }, '')
        .trim();
}

export default getErrorTranslations;
